// Development API Mock
const MOCK_PROJECTS = [
  {
    id: 1,
    title_tr: "Güneş Enerjisi Santrali - Ankara",
    title_en: "Solar Power Plant - Ankara",
    description_tr: "Ankara bölgesinde kurulu olan modern güneş enerjisi santrali projesi. Bu tesis, yılda 75 GWh elektrik üretimi kapasitesine sahiptir.",
    description_en: "Modern solar power plant project located in Ankara region. This facility has an annual electricity generation capacity of 75 GWh.",
    image_url: "/images/default-project.svg",
    capacity: "50 MW",
    location_tr: "Ankara, Türkiye",
    location_en: "Ankara, Turkey",
    completion_date: "2024-06-15",
    category: "solar",
    is_featured: 1,
    created_at: "2024-01-15 10:30:00",
    updated_at: "2024-01-15 10:30:00"
  },
  {
    id: 2,
    title_tr: "Rüzgar Enerjisi Santrali - İzmir",
    title_en: "Wind Power Plant - Izmir",
    description_tr: "İzmir'in yüksek rüzgar potansiyeline sahip bölgesinde kurulmuş olan rüzgar enerjisi santrali.",
    description_en: "Wind power plant established in the high wind potential region of Izmir.",
    image_url: "/images/default-project.svg",
    capacity: "75 MW",
    location_tr: "İzmir, Türkiye",
    location_en: "Izmir, Turkey",
    completion_date: "2024-03-20",
    category: "wind",
    is_featured: 0,
    created_at: "2024-02-10 14:20:00",
    updated_at: "2024-02-10 14:20:00"
  },
  {
    id: 3,
    title_tr: "Hidroelektrik Santrali - Artvin",
    title_en: "Hydroelectric Power Plant - Artvin",
    description_tr: "Artvin bölgesindeki doğal su kaynaklarından faydalanarak elektrik üretimi yapan hidroelektrik santrali.",
    description_en: "Hydroelectric power plant that generates electricity by utilizing natural water resources in the Artvin region.",
    image_url: "/images/default-project.svg",
    capacity: "25 MW",
    location_tr: "Artvin, Türkiye",
    location_en: "Artvin, Turkey",
    completion_date: "2023-12-10",
    category: "hydro",
    is_featured: 1,
    created_at: "2023-10-05 09:15:00",
    updated_at: "2023-10-05 09:15:00"
  }
]

let mockProjectIdCounter = 4

export const mockProjectsApi = {
  async getProjects(params = {}) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredProjects = [...MOCK_PROJECTS]
        
        // Search filter
        if (params.search) {
          const searchTerm = params.search.toLowerCase()
          filteredProjects = filteredProjects.filter(project => 
            project.title_tr.toLowerCase().includes(searchTerm) ||
            project.title_en.toLowerCase().includes(searchTerm) ||
            project.description_tr.toLowerCase().includes(searchTerm) ||
            project.description_en.toLowerCase().includes(searchTerm)
          )
        }
        
        // Category filter
        if (params.category) {
          filteredProjects = filteredProjects.filter(project => project.category === params.category)
        }
        
        // Featured filter
        if (params.featured !== undefined && params.featured !== '') {
          filteredProjects = filteredProjects.filter(project => 
            project.is_featured === parseInt(params.featured)
          )
        }
        
        // Pagination
        const page = parseInt(params.page) || 1
        const limit = parseInt(params.limit) || 12
        const offset = (page - 1) * limit
        const paginatedProjects = filteredProjects.slice(offset, offset + limit)
        
        resolve({
          success: true,
          message: 'Projeler listelendi',
          data: {
            projects: paginatedProjects,
            pagination: {
              current_page: page,
              per_page: limit,
              total: filteredProjects.length,
              total_pages: Math.ceil(filteredProjects.length / limit)
            }
          }
        })
      }, 500) // Simulate network delay
    })
  },

  async createProject(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newProject = {
          id: mockProjectIdCounter++,
          ...data,
          is_featured: data.is_featured ? 1 : 0,
          created_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
          updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
        }
        
        MOCK_PROJECTS.push(newProject)
        
        resolve({
          success: true,
          message: 'Proje başarıyla oluşturuldu',
          data: newProject
        })
      }, 500)
    })
  },

  async updateProject(id, data) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const projectIndex = MOCK_PROJECTS.findIndex(p => p.id === parseInt(id))
        
        if (projectIndex === -1) {
          reject(new Error('Proje bulunamadı'))
          return
        }
        
        MOCK_PROJECTS[projectIndex] = {
          ...MOCK_PROJECTS[projectIndex],
          ...data,
          id: parseInt(id),
          is_featured: data.is_featured ? 1 : 0,
          updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
        }
        
        resolve({
          success: true,
          message: 'Proje başarıyla güncellendi',
          data: MOCK_PROJECTS[projectIndex]
        })
      }, 500)
    })
  },

  async deleteProject(id) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const projectIndex = MOCK_PROJECTS.findIndex(p => p.id === parseInt(id))
        
        if (projectIndex === -1) {
          reject(new Error('Proje bulunamadı'))
          return
        }
        
        MOCK_PROJECTS.splice(projectIndex, 1)
        
        resolve({
          success: true,
          message: 'Proje başarıyla silindi',
          data: { id: parseInt(id) }
        })
      }, 500)
    })
  }
}